import axiosInstance from "./apiinterseptor";
import { toast } from "react-hot-toast";

export interface UnblockRequestData {
  reason?: string;
}

export interface UnblockRequest {
  _id: string;
  requestId: string;
  requestedBy: {
    _id: string;
    username: string;
    email: string;
    role: string;
    isBlocked: boolean;
  };
  status: 'pending' | 'approved' | 'rejected';
  reason?: string;
  reviewedBy?: {
    _id: string;
    username: string;
    email: string;
    role: string;
  };
  reviewedAt?: string;
  reviewNotes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UnblockRequestListResponse {
  success: boolean;
  data: {
    requests: UnblockRequest[];
    pagination: {
      page: number;
      limit: number;
      totalPages: number;
      totalResults: number;
    };
  };
}

export interface UnblockRequestResponse {
  success: boolean;
  data: UnblockRequest;
  message: string;
}

// Create a new unblock request
export const createUnblockRequest = async (requestData: UnblockRequestData): Promise<UnblockRequestResponse> => {
  try {
    const response = await axiosInstance.post('/unblock-requests', requestData);
    return response.data;
  } catch (error: any) {
    console.error("Failed to create unblock request:", error.response?.data?.message);
    throw new Error(error.response?.data?.message || 'Failed to create unblock request');
  }
};

// Get user's unblock requests
export const getUserUnblockRequests = async (
  page: number = 1,
  limit: number = 10
): Promise<UnblockRequestListResponse> => {
  try {
    const response = await axiosInstance.get('/unblock-requests/my-requests', {
      params: { page, limit }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch unblock requests:", error.response?.data?.message);
    throw new Error(error.response?.data?.message || 'Failed to fetch unblock requests');
  }
};

// Get unblock requests for review (SHM and Admin only)
export const getUnblockRequestsForReview = async (
  page: number = 1,
  limit: number = 10,
  status?: string
): Promise<UnblockRequestListResponse> => {
  try {
    const response = await axiosInstance.get('/unblock-requests/review', {
      params: { page, limit, status }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch unblock requests for review:", error.response?.data?.message);
    throw new Error(error.response?.data?.message || 'Failed to fetch unblock requests for review');
  }
};

// Update unblock request status (approve/reject) - SHM and Admin only
export const updateUnblockRequestStatus = async (
  requestId: string,
  status: 'approved' | 'rejected',
  reviewNotes?: string
): Promise<UnblockRequestResponse> => {
  try {
    const response = await axiosInstance.patch(`/unblock-requests/${requestId}/status`, {
      status,
      reviewNotes
    });
    toast.success(`Unblock request ${status} successfully`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to update unblock request status:", error.response?.data?.message);
    toast.error(error.response?.data?.message || 'Failed to update unblock request status');
    throw new Error(error.response?.data?.message || 'Failed to update unblock request status');
  }
};

